<template>
  <div class="candidate-page-root">
    <div class="candidate-page-wrapper">
      <VRow>
        <VCol cols="12" md="6" class="px-6 pl-md-10 pr-md-8 pl-lg-14 pr-lg-12">
          <div
            :class="{ 'candidate-left-part--blurred': isQuotaExceededForCard }"
          >
            <CandidateHeader
              :candidate="candidate"
              :readonly="readonly"
              :vacancy="vacancy"
            />
          </div>
          <CandidateInterviewResolver
            ref="interviewResolver"
            :vacancy="vacancy"
            :candidate="candidate"
            :readonly="readonly"
            :are-questions-equal="areQuestionsEqual"
            :is-quota-exceeded="isQuotaExceededForCard"
            @expanded="toggleExpanded"
            size="14"
            @online-interview-played="onlineInterviewPlayed"
          />
          <CandidateFooter
            :vacancy="vacancy"
            :candidate="candidate"
            :show-neighbours="showNeighbours"
          />
        </VCol>
    <VCol
      cols="12"
      md="6"
      class="py-0 pa-md-0"
      :class="{ 'candidate-right-col--blurred': isQuotaExceededForCard }"
    >
      <VCard
        outlined
        flat
        tile
        class="right-panel pa-md-0 fill-height light-background"
      >
        <CandidateTabsPanel
          v-model="activeTab"
          :vacancy="vacancy"
          :candidate="candidate"
          :readonly="readonly"
          :show-questions-tab="showQuestionsTab"
          :question="activeQuestion"
          :pdf-resume-loading="pdfResumeLoading"
          :are-questions-equal="areQuestionsEqual"
          @updated:question="activeQuestion = $event"
          @show-interview="changeShowOfficeInterview($event)"
          @show-online-interview="changeShowOnOnlineInterview"
          @generate-candidate-pdf="generatePDF"
        />
      </VCard>
    </VCol>
      </VRow>
    <VDialog v-model="wsDeletedDialog" persistent max-width="600">
      <VCard>
        <DialogHeader
          :title="$t('candidateRemoved')"
          text-class="error--text"
          @close="wsDeletedConfirm"
        />
        <VCardText class="pa-5">
          {{ $t('candidateRemovedTip') }}
        </VCardText>
        <VCardActions>
          <VSpacer />
          <VBtn text color="primary" @click="wsDeletedConfirm">
            {{ $t('toCandidateList') }}
          </VBtn>
        </VCardActions>
      </VCard>
    </VDialog>
    </div>
    <div class="pdf-summary" ref="pdf">
      <div class="pdf-summary__wrap">
        <div class="pdf-summary__wrap_info">
          <div>{{ $t('vacancy') }}: {{ vacancy.title }}</div>
          <div>
            {{ $t('candidate') }}: {{ candidateFullName }}
          </div>
          <div>{{ $t('evaluationCandidate') }}: {{ candidate.rating }}</div>
          <div>{{ $t('evaluationCandidateAi') }}: {{ aiRating / 2 }}</div>
          <CandidateRating
            :candidate="candidate"
            :align="$vuetify.breakpoint.mdAndUp ? 'align-end': 'align-start'"
            size="16"
          />
          <div class="pdf-summary__wrap_ai-review">
            {{ aiReview }}
          </div>
        </div>

        <div class="pdf-summary__wrap_ai-summary">
          {{ $t('summaryInterview') }}
        </div>
        <div
          class="pdf-summary__wrap_questions"
          v-for="(q, index) of vacancy.script.questions"
          :key="q.id"
        >
          <template v-for="t in isTranscriptions">
            <template
              v-if="q.id === t.questionId && t.transcription"
            >
              <div class="pdf-summary__wrap_q">
                <div class="pdf-summary__wrap_q-number">
                  {{ `${index + 1})` }}
                </div>{{ q.question }}
              </div>
              <div>{{ t.transcription }}</div>
            </template>
          </template>
        </div>

        <div class="pdf-summary__wrap_logo">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="162"
            height="26"
            viewBox="0 0 162 26"
            fill="none"
          >
            <path d="M157.318 0H157.314C155.23 0 153.542 1.78216 153.542 3.98056V3.98535C153.542 6.18375 155.23 7.9659 157.314 7.9659H157.318C159.401 7.9659 161.09 6.18375 161.09 3.98535V3.98056C161.09 1.78216 159.401 0 157.318 0Z" fill="#EA0D0D" />
            <path d="M16.5307 5.80576V25.9241H12.7089V19.8982H3.81268V25.9337H0V5.81534H3.81268V15.8745H12.7089V5.81534L16.5307 5.80576Z" fill="#212121" />
            <path d="M41.7162 17.2109C41.7162 19.5244 40.8454 21.743 39.2954 23.3788C37.7453 25.0147 35.643 25.9337 33.4509 25.9337C31.2588 25.9337 29.1565 25.0147 27.6064 23.3788C26.0564 21.743 25.1855 19.5244 25.1855 17.2109V5.80576H29.0028V17.2109C29.0028 18.4559 29.4714 19.6499 30.3056 20.5303C31.1398 21.4106 32.2712 21.9052 33.4509 21.9052C34.6306 21.9052 35.762 21.4106 36.5962 20.5303C37.4304 19.6499 37.899 18.4559 37.899 17.2109V5.80576H41.7162V17.2109Z" fill="#212121" />
            <path d="M50.3809 5.80576H51.3976L63.0898 17.5606V5.80576H66.9025V25.9241H65.8585L54.189 14.1788V25.9337H50.3809V5.80576Z" fill="#212121" />
            <path d="M73.9121 5.80576H90.4383V9.83421H84.0838V25.9337H80.2666V9.83421H73.9121V5.80576Z" fill="#212121" />
            <path d="M101.263 25.9332H97.4453V5.8149H101.263V25.9332Z" fill="#212121" />
            <path d="M118.101 5.80571C119.579 5.80292 121.038 6.16282 122.361 6.85697C123.684 7.55113 124.837 8.56053 125.727 9.80543L126.108 10.3419L123.081 12.7849L122.699 12.2484C121.978 11.236 120.974 10.4884 119.828 10.1113C118.683 9.73419 117.454 9.74672 116.315 10.1471C115.176 10.5474 114.186 11.3153 113.483 12.3423C112.781 13.3692 112.402 14.6032 112.401 15.8697C112.403 17.4668 113.004 18.9981 114.072 20.1296C115.14 21.2611 116.588 21.9011 118.101 21.91C118.988 21.916 119.864 21.7024 120.659 21.2865C121.453 20.8705 122.145 20.2638 122.677 19.5149L123.058 18.9784L126.085 21.4166L125.727 21.9339C124.748 23.2991 123.456 24.3781 121.972 25.0688C120.487 25.7595 118.861 26.0391 117.246 25.8811C115.631 25.7231 114.08 25.1327 112.742 24.1659C111.403 23.199 110.321 21.8877 109.596 20.356C108.872 18.8243 108.53 17.1228 108.603 15.4128C108.676 13.7027 109.161 12.0405 110.013 10.5836C110.865 9.12673 112.054 7.92327 113.47 7.08718C114.885 6.25109 116.479 5.81001 118.101 5.80571V5.80571Z" fill="#212121" />
            <path d="M146.203 22.5806H136.39L134.661 25.9336H130.312L141.297 4.70877L152.308 25.9336H147.969L146.203 22.5806ZM144.12 18.5569L141.297 13.0818L138.473 18.5569H144.12Z" fill="#212121" />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { mapGetters } from 'vuex';
import {
  candidateLogType, interviewStatusType, interviewType, vacancyStatus,
} from '@/enums';
import CandidateRating from '@/components/Candidate/CandidateRating.vue';
import {
  computed, toRefs, ref, onMounted,
} from '@vue/composition-api';
import useAccount from '@/compositions/accounting/useAccount';
import CandidateHeader from './CandidateHeader.vue';
import CandidateInterviewResolver from './CandidateInterviewResolver.vue';
import CandidateTabsPanel from './CandidateTabsPanel.vue';
import CandidateFooter from './CandidateFooter.vue';
import Candidate from '../../orm/models/Candidate/Candidate';
import DialogHeader from '../DialogHeader.vue';
import ValidationMixin from '../../mixins/ValidationMixin';

export default {
  name: 'Candidate',
  metaInfo() {
    return {
      title: 'Интервью',
    };
  },
  components: {
    CandidateRating,
    DialogHeader,
    CandidateFooter,
    CandidateHeader,
    CandidateTabsPanel,
    CandidateInterviewResolver,
  },
  mixins: [ValidationMixin],
  props: {
    vacancy: {
      type: Object,
      required: true,
    },
    candidate: {
      type: Object,
      required: true,
    },
    showInterviewId: {
      type: Number,
      required: false,
      default: null,
    },
    showNeighbours: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup(props) {
    const { candidate, vacancy } = toRefs(props);
    const { quota, fetchIfNull } = useAccount();
    const pdfResumeLoading = ref(false);

    onMounted(() => {
      fetchIfNull();
    });

    const isTranscriptions = computed(() => {
      return candidate.value?.interview?.timestamps?.filter((i) => {
        return i.transcription;
      });
    });

    const aiRating = computed(() => candidate.value?.interview?.aiRating);
    const aiReview = computed(() => candidate.value?.interview?.aiReview);

    const areQuestionsEqual = computed(() => {
      const vacancyQuestionIds = new Set((vacancy.value?.script?.questions || [])?.map((q) => q.id));
      const candidateQuestionIds = new Set(candidate.value?.interview?.timestamps?.map((q) => q.questionId));

      if (!vacancyQuestionIds.size || !candidateQuestionIds.size) {
        return true;
      }

      if (candidateQuestionIds.size !== vacancyQuestionIds.size) return false;
      for (const id of vacancyQuestionIds) {
        if (!candidateQuestionIds.has(id)) return false;
      }
      return true;
    });

    const candidateFullName = computed(() => `${candidate.value.firstName} ${candidate.value.lastName}`);
    function generatePDF() {
      pdfResumeLoading.value = true;
      const content = this.$refs.pdf;

      html2canvas(content).then((canvas) => {
        const componentWidth = content.offsetWidth;
        const componentHeight = content.offsetHeight;

        const orientation = componentWidth >= componentHeight ? 'l' : 'p';

        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF({
          orientation,
          unit: 'px',
          format: 'a4',
          hotfixes: ['px_scaling'],
        });

        pdf.internal.pageSize.width = componentWidth;
        pdf.internal.pageSize.height = componentHeight;

        pdf.addImage(imgData, 'PNG', 10, 10, componentWidth, componentHeight);
        pdf.save(`${candidateFullName.value}`);
        pdfResumeLoading.value = false;
      });
    }

    return {
      isTranscriptions,
      candidateFullName,
      generatePDF,
      aiRating,
      aiReview,
      pdfResumeLoading,
      areQuestionsEqual,
      quota,
    };
  },
  data() {
    return {
      showOfficeInterviewId: null,
      candidateEditMode: false,
      wsDeletedDialog: false,
      expanded: false,
    };
  },
  computed: {
    ...mapGetters('candidatePage', ['activeInterviewType']),
    activeTab: {
      get() {
        return this.$store.state.candidatePage.activeTab;
      },
      set(value) {
        this.$store.commit('candidatePage/setActiveTab', value);
      },
    },
    isRefused() {
      return this.candidate.logs?.some((log) => log.eventType === candidateLogType.REFUSED)
        || this.candidate.selfRefused;
    },
    activeQuestion: {
      get() {
        return this.$store.state.candidatePage.activeQuestion;
      },
      set(value) {
        this.$store.commit('candidatePage/setActiveQuestion', value);
      },
    },
    readonly() {
      return (this.vacancy.status !== vacancyStatus.ACTIVE || this.isRefused)
        && !this.candidate.selfRefused;
    },
    showQuestionsTab() {
      return this.candidate.interview?.status === interviewStatusType.READY
        && this.activeInterviewType === interviewType.ONLINE_INTERVIEW && !this.expanded;
    },
    isQuotaExceededForCard() {
      return this.quota
        && Number(this.quota.interviews ?? 0) < 1
        && !this.candidate.quotaWrittenOff;
    },
  },
  async created() {
    this.$echo.private(`company.${this.vacancy.companyId}`)
      .listen('.candidate.destroyed', (data) => {
        if (String(data.id) === String(this.candidate.id)) {
          this.wsDeletedDialog = true;
        }
      });

    this.applyTabFromQuery();
  },
  mounted() {
    this.$nextTick(() => {
      this.applyTabFromQuery();
    });
  },
  watch: {
    '$route.query.tab'() {
      this.applyTabFromQuery();
    },
    showQuestionsTab() {
      this.applyTabFromQuery();
    },
  },
  methods: {
    applyTabFromQuery() {
      if (this.$route.query.tab !== 'contact') {
        return;
      }

      this.activeTab = this.showQuestionsTab ? 2 : 1;
    },
    changeShowOfficeInterview(newId) {
      this.$refs.interviewResolver.changeShowOfficeInterview(newId);
    },
    changeShowOnOnlineInterview() {
      this.$refs.interviewResolver.changeShowOnOnlineInterview();
    },
    onlineInterviewPlayed() {
      this.activeTab = 1;
    },
    async wsDeletedConfirm() {
      this.wsDeletedDialog = false;
      const { id } = this.candidate;
      await this.$router.push({ name: 'candidates' });
      await Candidate.delete(id);
    },
    toggleExpanded(flag) {
      // фикс проблемы с миганием видео при наведении на список вопросов после выхода
      // из фулскрина
      this.activeTab = flag ? 0 : 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.candidate-page-root {
  position: relative;
  width: 100%;
}

.candidate-page-wrapper {
  position: relative;
  width: 100%;
}

.candidate-left-part--blurred,
.candidate-right-col--blurred {
  filter: blur(4px);
  pointer-events: none;
  user-select: none;
}

.pdf-summary {
  position: absolute;
  z-index: -99;
  max-width: 750px;
  &__wrap {
    position: relative;
    padding: 25px;
    &_ai-review {
      margin-top: 10px;
    }
    &_ai-summary {
      margin-top: 30px;
    }
    &_questions {
      margin-top: 10px;
    }
    &_q {
      margin: 5px 0;
      display: flex;
    }
    &_q-number {
      margin-right: 3px;
    }
    &_logo {
      position: absolute;
      top: 25px;
      right: 25px;
    }
  }
}
</style>

<i18n locale="en" lang="yaml">
  candidateRemoved: The candidate was removed
  candidateRemovedTip: Someone removed the candidate while you were working with them.
  toCandidateList: Candidate list
  vacancy: Job
  candidate: Candidate
  evaluationCandidate: Evaluation of the candidate
  evaluationCandidateAi: Evaluation of the candidate from AI
  summaryInterview: Summary of the interview
</i18n>

<i18n locale="ru" lang="yaml">
  candidateRemoved: Кандидат удалён
  candidateRemovedTip: Кто-то удалил этого кандидата, либо вы удалили его в другом окне браузера.
  toCandidateList: К списку кандидатов
  vacancy: Вакансия
  candidate: Кандидат
  evaluationCandidate: Оценка кандидата
  evaluationCandidateAi: Оценка кандидата от ИИ
  summaryInterview: Краткое содержание интервью
</i18n>
